import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-epso-fee-assistance',
  imports: [PillarPagesTemp],
  templateUrl: './epso-fee-assistance.html',
  styleUrl: './epso-fee-assistance.scss',
})
export class EpsoFeeAssistance {

}
